import React,{useContext, useState} from 'react';
import { useHistory } from "react-router-dom";

import Modal from '../../../modal/Modal';
import {ContextPlayer} from '../../player/PlayerProvider';
import {getRankingPosition} from '../../../store/storeRanking';
import {parseTimeToString} from '../../../Utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTwitter, faFacebook, faWhatsapp} from '@fortawesome/free-brands-svg-icons';

import  Piii from 'piii';
import PiiiFilters from 'piii-filters';

import Warning from './warning/Warning';
 
import './ModalWin.css';

const message = moves => {
	if(moves <= 29){
		return "Você é um especialista!";
	}else if(moves <=32){
		return "Você alcançou um ótimo resultado!";
	}else if(moves <= 36){
		return "Treine um pouco mais e se tornará um expert!";
	}else if(moves <= 39){
		return "Vamos treinar um pouco mais?";
	}
	return "Vamos jogar novamente?";
	
}

const ModalWin = ({visible}) => {

    const {state, dispatch} = useContext(ContextPlayer);
    const [war, setWar] = useState(false);

    let history = useHistory();
    
    const piii = new Piii({
        filters: [
          [...Object.values(PiiiFilters)]
        ],
        aliases: {
          a: ["2", "4", "@"],
          e: ["3", "&"],
          o: ["0",'u'],
          i: ['1','|','l']
        }
      });
  

    const handleSalvar = () => {
        const playerName = document.getElementById("namePlayer").value || "Desconhecido";
        
        if(!piii.has(playerName)){
            dispatch({type:"UpdateData", name:playerName});
            history.push('/rank');
        }else{
            setWar(true);
        }
    };

    const handleWarning = () => {
        setWar(!war);
    }

    const encodeLink = "http://eic.ifsc.usp.br/app/CNPD-v2";

    const handleWhatsapp = () => {
        window.open('https://api.whatsapp.com/send?text=Terminei o jogo em '+parseTimeToString(state.timeout)+'s e Você? Venha jogar o Conhecimento na Ponta dos Dedos e outros jogos no: '+encodeLink,'_system', 'location=yes'); 
        return false;
    }

    const handleTwitter = () => {
        const link = "https://twitter.com/intent/tweet?hashtags=eiciencias&original_referer=https%3A%2F%2Fpublish.twitter.com%2F%3FbuttonHashtag%3Deiciencias%26buttonRecommendation%3D%2540eiciencias%26buttonText%3DTerminei%2520o%2520jogo%2520em%2520e%2520Voc%25C3%25AA%253F%26buttonType%3DTweetButton%26buttonUrl%3Dhttp%253A%252F%252Feic.ifsc.usp.br%252F%26widget%3DButton&ref_src=twsrc%5Etfw&related=%40eiciencias&text=Terminei%20o%20jogo%20em%20"+parseTimeToString(state.timeout)+"s%20e%20Você%3F%20Venha%20jogar%20o%20Conhecimento%20na%20Ponta%20dos%20Dedos%20e%20outros%20jogos%20no%3A&tw_p=tweetbutton&url="+encodeLink;
        window.open(link,'_system', 'location=yes'); 
    }

    const handleFacebook = () => {
        const link = "https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Feic.ifsc.usp.br%2Fapp%2FCNPD-v2&amp;src=sdkpreparse";
        window.open(link,'_system', 'location=yes'); 
    }

    return(
        <Modal visible = {visible}>
            <div className="modalWin column nowrap centerItens centerText shadow">
                <div className = 'head'>
                    Vitória
                </div>
                <img className="trophy" src="/app/CNPD-v2/images/layout/win/trophy.png" alt="Troféu"/>
                <span className="title">Parabéns</span>
                <span className = "message">
                    {message(state.moves)}  
                </span>
                <span className="content">
                    Terminou o jogo em {parseTimeToString(state.timeout)} <br/>e ficou {getRankingPosition(state)+1}º lugar.
                </span>
                <span className="titleButton">Salve sua conquista <br/> Digite o seu nome</span>
                <input id="namePlayer" type="text" maxLength={25} className="input centerText"/>
                <div className = "bottom row nowrap spaceBetweenContent">
                    <div className="compartilhar row nowrap">
                        <div  onClick={handleWhatsapp} className="button shadow backgroundEIC row nowrap centerItens" >
                            <FontAwesomeIcon icon = {faWhatsapp}/>
                        </div>
                        <div onClick = {handleTwitter} className="button shadow backgroundEIC row nowrap centerItens" >
                            <FontAwesomeIcon icon = {faTwitter}/>
                        </div>
                        <div onClick ={handleFacebook} className="button shadow backgroundEIC row nowrap centerItens" >
                            <FontAwesomeIcon icon = {faFacebook}/>
                        </div>
                    </div>
                    <button className="button shadow" onClick={handleSalvar}>Salvar</button>
                </div>
                <Warning handler = {handleWarning} visible = {war}/>   
            </div>
        </Modal>
    );
};

export default ModalWin;